import React, { useState } from 'react';
import { Modal, Box, Typography, IconButton } from '@mui/material';
import { XIcon, InformationCircleIcon } from "@heroicons/react/solid";
import Button from '../../components/ui/Button';
import ToggleButton from '../../components/ui/ToggleButton';
import ViewServiceLogsModal from './ViewServiceLogsModal';
import ToolTip from '../../components/ui/ToolTip';

const EmployeeServicesModal = ({ open, onClose }) => {
  // Static service data with descriptions
  const [services, setServices] = useState([
    { 
      id: 'hrms', 
      name: 'HRMS', 
      enabled: true,
      description: 'Human Resource Management System - Provides complete employee management, including attendance tracking, leave management, and performance evaluation.'
    },
    { 
      id: 'liveTracking', 
      name: 'Live Tracking', 
      enabled: false,
      description: 'Real-time employee location tracking system that helps monitor field staff movements and optimize workforce distribution.'
    },
  ]);

  // Static logs data
  const serviceLogs = {
    hrms: [
      { type: 'enabled', date: '10-03-2025', user: 'Admin' },
      { type: 'disabled', date: '05-03-2025', user: 'Admin' },
      { type: 'enabled', date: '01-03-2025', user: 'Admin' },
    ],
    liveTracking: [
      { type: 'disabled', date: '12-03-2025', user: 'Admin' },
      { type: 'enabled', date: '10-03-2025', user: 'Admin' },
    ]
  };

  const [selectedService, setSelectedService] = useState(null);
  const [isLogsModalOpen, setIsLogsModalOpen] = useState(false);

  const handleToggleService = (serviceId) => {
    setServices(services.map(service => 
      service.id === serviceId 
        ? { ...service, enabled: !service.enabled } 
        : service
    ));
  };

  const openLogsModal = (serviceId) => {
    setSelectedService(serviceId);
    setIsLogsModalOpen(true);
  };

  const closeLogsModal = () => {
    setIsLogsModalOpen(false);
  };

  // Get service name for the selected service
  const getSelectedServiceName = () => {
    const service = services.find(s => s.id === selectedService);
    return service ? service.name : '';
  };

  // Get logs for the selected service
  const getSelectedServiceLogs = () => {
    return selectedService ? serviceLogs[selectedService] || [] : [];
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          bgcolor: 'background.paper',
          borderRadius: '8px',
          boxShadow: 24,
          p: 4,
        }}>
          <div className="flex justify-between items-center mb-4">
            <Typography variant="h6" component="h2" className="font-bold text-lg">
              Services
            </Typography>
            <IconButton onClick={onClose} size="small">
              <XIcon className="h-5 w-5" />
            </IconButton>
          </div>

          <div className="border rounded-md overflow-hidden">
            {services.map((service) => (
              <div key={service.id} className="flex justify-between items-center p-4 border-b last:border-b-0">
                <div className="flex items-center">
                  <div className="font-medium mr-2">{service.name}</div>
                  <ToolTip content={service.description}>
                    <InformationCircleIcon className="h-5 w-5 text-gray-500 hover:text-primary cursor-pointer" />
                  </ToolTip>
                </div>
                <div className="flex items-center space-x-3">
                  {/* <Button 
                    variant="outline" 
                    size="default"
                    onClick={() => openLogsModal(service.id)}
                  >
                    View Logs
                  </Button> */}
                  <ToggleButton 
                    isChecked={service.enabled} 
                    onChange={() => handleToggleService(service.id)} 
                    variant={service.enabled ? "success" : "default"}
                  />
                </div>
              </div>
            ))}
          </div>
        </Box>
      </Modal>

      {/* Service Logs Modal */}
      <ViewServiceLogsModal
        open={isLogsModalOpen}
        onClose={closeLogsModal}
        serviceName={getSelectedServiceName()}
        logs={getSelectedServiceLogs()}
      />
    </>
  );
};

export default EmployeeServicesModal;